module.exports = __webpack_public_path__ + "img/1-6.7057c10b.png";